import angular from 'angular';
import constants from 'app/constants';
import {
  bcpDataService,
  loaderService,
  ssDialogService,
} from 'app/services';
import { alerts } from 'app/components/global';
import controller from './change-procedure-confirm-dialog.controller';
import template from './change-procedure-confirm-dialog.html';


class dialogService {
  getOptions($event, {
    assessmentId,
    processes,
    dfdItem
  }) {
    return {
      controller,
      controllerAs: 'changeProcedureConfirmDialogVM',
      locals: {
        assessmentId,
        processes,
        dfdItem
      },
      escapeToClose: false,
      clickOutsideToClose: false,
      targetEvent: $event,
      template,
    };
  }
}

export default angular.module('app.components.advisory.bcp.changeProcedureConfirmDialog', [
  alerts,
  bcpDataService,
  constants,
  loaderService,
  ssDialogService,
])
  .service('changeProcedureConfirmDialog', dialogService)
  .name;
